import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

export type TextsSettingsParams = {
  aboutSectionTitleText: SettingsParamType.Text
  reservationSectionTitleText: SettingsParamType.Text
  reserveNowButtonText: SettingsParamType.Text
  requestNowButtonText: SettingsParamType.Text
  noReservationText: SettingsParamType.Text
}

export const textsSettingsParams = createSettingsParams<TextsSettingsParams>({
  aboutSectionTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-experiences.experience-details.section.about-experience'),
  },
  reservationSectionTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-experiences.experience-details.section.reservation'),
  },
  reserveNowButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-experiences.experience-details.reserve-now-cta'),
  },
  requestNowButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-experiences.experience-details.request-now-cta'),
  },
  noReservationText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) =>
      t('uou-experiences.experience-details.section.reservation.not-accepting'),
  },
})
